import { CollectionWithWorkItemCounts, WorkitemStatus } from './types';

export function categorizeProjects(projects: CollectionWithWorkItemCounts[]): {
  active: CollectionWithWorkItemCounts[];
  forReview: CollectionWithWorkItemCounts[];
  archived: CollectionWithWorkItemCounts[];
} {
  const active: CollectionWithWorkItemCounts[] = [];
  const forReview: CollectionWithWorkItemCounts[] = [];
  const archived: CollectionWithWorkItemCounts[] = [];

  for (const project of projects) {
    if (project.availability === false) {
      archived.push(project);
      continue;
    }

    const toDoCount = project.workItemCounts?.[WorkitemStatus.IN_CQA] ?? -1;
    const completeCount = project.workItemCounts?.[WorkitemStatus.CQA_COMPLETE] ?? -1;

    if (toDoCount === -1) {
      // Counts not yet loaded — show in active so the project is visible immediately
      active.push(project);
    } else if (toDoCount > 0) {
      active.push(project);
    } else if (completeCount > 0) {
      forReview.push(project);
    } else {
      archived.push(project);
    }
  }

  return { active, forReview, archived };
}
